/* PC53 one-of-a-kind card storefront guard.
   Shopify inventory tracking and checkout rules must ALSO be enabled.
   This UI guard cannot replace Shopify's server-side inventory enforcement. */
(function () {
  'use strict';
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  if (!root.endsWith('/')) root += '/';
  function cart() {
    return fetch(root + 'cart.js', {credentials:'same-origin'}).then(function (r) {
      if (!r.ok) throw new Error('Unable to check cart');
      return r.json();
    });
  }
  function change(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line,quantity:quantity})
    }).then(function(r) {
      if (!r.ok) throw new Error('Unable to update cart');
      return r.json();
    });
  }
  document.addEventListener('submit', function(e) {
    var form=e.target;
    if (!form.matches('form[action*="/cart/add"]') || form.dataset.pc53Submitting==='true') return;
    e.preventDefault();
    var id=form.querySelector('[name="id"]');
    if (!id) return;
    var qty=form.querySelector('[name="quantity"]');
    if (qty) qty.value='1';
    var button=form.querySelector('[type="submit"]');
    if(button) button.disabled=true;
    cart().then(function(c) {
      if(c.items.some(function(item){return String(item.variant_id)===String(id.value);})) {
        alert('This one-of-a-kind card is already in your cart. Only one can be purchased.');
        return;
      }
      form.dataset.pc53Submitting='true';
      HTMLFormElement.prototype.submit.call(form);
    }).catch(function() {
      alert('Could not verify your cart. Please try again.');
    }).finally(function() {if(button) button.disabled=false;});
  },true);

  // Remove a single cart line without allowing quantity increases.
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-pc53-remove-line]');
    if (!button || button.disabled) return;
    var line = Number(button.getAttribute('data-pc53-remove-line'));
    if (!Number.isInteger(line) || line < 1) return;
    button.disabled = true;
    button.textContent = 'Removing…';
    change(line, 0).then(function() {
      window.location.reload();
    }).catch(function() {
      button.disabled = false;
      button.textContent = 'Remove';
      alert('Unable to remove this card. Please try again.');
    });
  });

  if (document.querySelector('[data-pc53-checkout]')) {
    var checkout=document.querySelector('[data-pc53-checkout]');
    checkout.disabled=true;
    cart().then(function(c) {
      var duplicate=c.items.findIndex(function(item){return item.quantity>1;});
      if(duplicate<0) {checkout.disabled=false;return;}
      return change(duplicate+1,1).then(function(){location.reload();});
    }).catch(function(){
      var warning=document.createElement('p');
      warning.textContent='Cart verification failed. Refresh this page before checkout.';
      checkout.parentNode.insertBefore(warning,checkout);
    });
  }
})();
